module.exports = __webpack_public_path__ + "img/ic_product_ops.9e5d5154.png";